<template>
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-12 d-flex flex-column align-items-center justify-content-center vh-100">
      <div class="card auth-card w-100">
        <div class="card-body">
          <div class="col-10 offset-1">
            <h2 class="title text-center">Login</h2>
            <h6 class="sub-title text-center">Enter your email and password.</h6>
            <p v-if="errorMessage" class="text-center text-danger">
              {{ errorMessage }}
            </p>
            <Form class="form" @submit="login">
              <div class="form-group">
                <Field id="email" v-model="loginObj.email" :rules="{ required: ['Email'], email: ['Email'] }"
                  type="email" name="email" class="form-control shadow-none" placeholder="Email" />
                <ErrorMessage name="email" class="form-text text-danger" />
              </div>
              <div class="form-group">
                <Field id="password" v-model="loginObj.password" :rules="{ required: ['Password'] }" type="password"
                  name="password" class="form-control shadow-none" placeholder="Password" />
                <ErrorMessage name="password" class="form-text text-danger" />
              </div>
              <div class="col-lg-12">
                <router-link :to="{ name: FORGOT_PASSWORD_ROUTE }" class="forgot-password">Forgot
                  Password?</router-link>
              </div>
              <button type="submit" class="btn btn-dark" :disabled="isLoading ? true : false">
                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-if="!isLoading">Continue</span>
              </button>
            </Form>
            <br />
            <!-- <span class="text-center auth-switch-link">Dont have an account?
              <router-link :to="{ name: SIGNUP_ROUTE }">Register</router-link>.</span> -->
          </div>
        </div>
      </div>
      <div class="copyright">
        <span class="text-center">&copy; copyright {{ new Date().getFullYear() }}, abol hr.</span>
      </div>
      <div class="copyright">
        <span class="text-center">powered by wysemonk technologies.</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';
import { email, min } from '@vee-validate/rules';
import { requestPushToken, getCachedPushToken } from '@/utils/fcm_bridge';

import {
  DASHBOARD_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  SIGNUP_ROUTE,
} from '@/router/routes';
import { LOGIN } from '@/store/action_types';
import { usePostHog } from '@/composables/posthog';

const { posthog } = usePostHog();

defineRule('email', email);
defineRule('required', (value, [fieldName = 'Field']) => {
  if (!value || value.length === 0) {
    return `${fieldName} is required`;
  }
  return true;
});


function withTimeout(p, ms = 2000) {
  return Promise.race([
    p.catch(() => null),
    new Promise<null>((resolve) => setTimeout(() => resolve(null), ms)),
  ]);
}

export default {
  title: 'Login',
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      FORGOT_PASSWORD_ROUTE,
      SIGNUP_ROUTE,
      isInApp: false,
      loginObj: {
        email: null,
        password: null,
        fcmToken: null
      },
    };
  },
  computed: {
    errorMessage() {
      return this.$store.getters.errorMsg;
    },
    account() {
      return this.$store.getters.account.data;
    },
    isLoading() {
      return this.$store.getters.account.isLoading;
    },
  },
  methods: {
    async login() {
      
      if(this.isInApp) {
        let token = getCachedPushToken();
        if (!token) {
          token = await withTimeout(requestPushToken(), 2000).catch(() => null);
        }

        console.log('fcmToken', token)

        if (token) this.loginObj.fcmToken = token
        else delete this.loginObj.fcmToken
      } else {
        delete this.loginObj.fcmToken
      }
      
      this.$store.dispatch(LOGIN, this.loginObj).then((res) => {
        if (res) {
          posthog.identify(this.account.id, {
            employeeEmail: this.account.email,
            employeeName: `${this.account.fname} ${this.account.lname}`,
            employeeId: this.account.id,
            organizationId: this.account.organizationId,
          });
          this.$router.push({ name: DASHBOARD_ROUTE });
        }
      });
    },
    isInWebView() {
      // Primary: explicit flag from the app
      if (window.__ABOLHR_INAPP__) return true;

      // Fallback heuristics (not perfect, but handy)
      const ua = navigator.userAgent || '';
      const isAndroidWV = /Android/.test(ua) && /\bwv\)/.test(ua);          // Android WebView "; wv)"
      const hasVersionToken = /Version\/\d+\.\d+/.test(ua) && /Chrome/.test(ua) && /\bwv\)/.test(ua);
      const isIOS = /iPhone|iPad|iPod/.test(ua);
      const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua); // WKWebView has no "Safari"
      return isAndroidWV || isIOSWebView || hasVersionToken;
    },
  },
  async mounted() {
    //  const prev = window.onNativePushToken;
    //   window.onNativePushToken = (t) => { prev?.(t); console.log('onNativePushToken', t); };

    //   console.log('Env:', {
    //     inapp: !!window.flutter_inappwebview,
    //     host: !!window.HostApp,
    //     onTok: typeof window.onNativePushToken,
    //   });

    this.isInApp = this.isInWebView()

    // ask for token with a timeout, then log it
    const token = await Promise.race([
      requestPushToken(),
      new Promise((resolve) => setTimeout(() => resolve('__timeout__'), 2000)),
    ]);
  }
};
</script>
<style scoped>
.info-section {
  width: 100%;
  height: 100%;
  background-color: #2E7918;
}

.auth-section {
  width: 50%;
}

.title {
  font-size: 1.6rem;
  line-height: 2.5rem;
  font-weight: 600;
}

.sub-title {
  font-weight: 400;
  font-size: 0.8rem;
  color: #71717a;
}

.form {
  margin-top: 2rem;
}

hr {
  border: 1px solid #e4e4e7;
}

.info-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: var(--app-height, 100vh);
  /* Make it take up the full visible viewport height */
  text-align: center;
  /* Ensure text is centered inside */
  color: #d5d3d3;
}

.col-6 {
  margin: auto;
  /* Center the .col-6 div inside its container */
}

.info-section .headline {
  font-size: 1.5rem;
  font-weight: 600;
}

.info-section .sub-headline {
  font-size: 0.9rem;
  font-weight: 300;
  margin-top: 20px;
  margin-bottom: 30px;
}

.info-section hr {
  border-color: grey;
}

@media (max-width: 1000px) {
  .auth-card {
    width: 92%!important;
  }
}
</style>
